import styled from 'styled-components';
import expandedLayoutProps from '../Box/expandedLayoutProps';
var Fieldset = styled.fieldset.withConfig({
  displayName: "Fieldset",
  componentId: "sc-1cuzqmv-0"
})(["border:0;padding:0;margin:0;min-width:0;", ";"], expandedLayoutProps);
Fieldset.defaultProps = {
  p: 'xxs'
};
export default Fieldset;